const config = {
    tables: {
        prevPageIcon: 'ni ni-bold-left',
        nextPageIcon: 'ni ni-bold-right'
    },

    forms: {
        formErrorAnimation: 'fade',
        formAnimation: 'fade'
    }
};

const defaultVariations = {
    form: {
        get () {
            return {
                animation: config.config.forms.formAnimation,

                /*
                *  Confirm Form Parameters
                */
                confirmOnSubmit: false,
                confirmMessage: 'Are you sure ?',
                confirmVariant: '',
                confirmTitle: 'Confirm',
                confirmYesText: 'Yes',
                confirmNoText: 'No',

                hideFormOnOptionsLoadingFailed: false,
                hideFormOnOptionsLoading: false,
                hideFormOnSave: false,

                loadInitialFromOptions: true,
                loadInitialFromOptionsParameter: 'initial',

                showConfirmPageBeforeSubmit: false,
                showErrorPageOnFailed: false,

                showNotificationOnFailed: false,
                failedNotificationText: 'Some errors occured while communicating with server. Please try again later.',

                showNotificationOnOptionsFailed: false,
                failedNotificationOptionsText: 'Some errors occured while communicating with server. Please try again later.'
            };
        }
    }
};

const optionsMapping = {};

const addVariation = function (type, name, params) {
    const defaultOptions = defaultVariations[type];
    if (!defaultOptions) {
        throw Error('Invalid type.');
    }
    let typeMapping = optionsMapping[type];
    if (!typeMapping) {
        typeMapping = {};
        optionsMapping[type] = typeMapping;
    }

    typeMapping[name] = {
        ...defaultOptions,
        ...params
    };
};

const getVariation = function (type, name = '') {
    const defaultOptions = defaultVariations[type];
    if (!defaultOptions) {
        throw Error('Invalid type.');
    }
    const typeMapping = optionsMapping[type];
    const variation = typeMapping[name];
    if (variation) {
        return {
            ...defaultOptions,
            ...variation
        };
    }
    return {
        ...defaultOptions
    };
};

const configure = function (name, params) {
    const conf = config[name];

    config[name] = {
        ...conf,
        ...params
    };
};

export default {
    config,
    configure,
    addVariation,
    getVariation
};
